import { render, staticRenderFns } from "./AppModalClose.vue?vue&type=template&id=125fbe42&scoped=true&"
import script from "./AppModalClose.vue?vue&type=script&lang=js&"
export * from "./AppModalClose.vue?vue&type=script&lang=js&"
import style0 from "./AppModalClose.vue?vue&type=style&index=0&id=125fbe42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fbe42",
  null
  
)

export default component.exports